import React from "react";
import { useState, useEffect , useContext } from 'react';
import ChartComponent from '../../../../components/chart';
import { Spin } from 'antd';
import Api from "../../../../services/api";
import {getColor,getDates, getBarSize} from '../../../../utility';
import ReChartComponent from "../../../../components/chartNew";

import { toast } from 'react-toastify';

const ChartPlatformCost = (props) => {
  const [loading,setLoading] = useState(false);
	const [chartPlatformCost,setChartPlatformCost] = useState([]);
  const [chartPlatformCostData,setChartPlatformCostData] = useState({
  	labels : [],
  	datasets : []
  });
	// const chartPlatformOptions = {
  //   indexAxis: 'y',
  //   elements: {
  //     bar: {
  //       borderWidth: 2,
  //     }
  //   },
  //   plugins: {
  //     legend: {
  //       display: false,
  //     },
  //     title: {
  //       display: true,
  //       position : "bottom",
  //       text: ''
  //     }
  //   },
  //     responsive: true,
  //     maintainAspectRatio : false,
  //     interaction: {
  //       axis: 'x',
  //       mode: 'index',
  //       intersect: false,
  //     },
  // };

  const chartPlatformOptions = {
    indexAxis: 'y',
    legend: false
  };

	useEffect(() => {
    setLoading(true)
    Api.get(`api/overview/cost_by_os?os=${props.os}&from=${props.startDate.format('YYYY-MM-DD')}&to=${props.endDate.format('YYYY-MM-DD')}&code=${props.code}&country=${props.country}&ad_network=${props.adnetwork}&campaign=${props.campaign}&index_filter=${props.filter}`)
    .then(result => {
      if(result?.data?.code === 0){
        setChartPlatformCost(result.data.data)
        setLoading(false)
      }
    });
  }, [props.reload, props.filter]);

  useEffect(() => {

    let labels = [];
    let datasets = [{
      label: `${props.startDate.format('YYYY-MM-DD')} - ${props.endDate.format('YYYY-MM-DD')}`,
      data: [],
      backgroundColor: [],
      barThickness : getBarSize
    }];


    chartPlatformCost.map((i,k) => {
  		labels.push(i.name)
        datasets[0].data.push(i.value)
        datasets[0].backgroundColor.push(getColor(k))
  	})

    setChartPlatformCostData({labels,datasets})
  }, [chartPlatformCost]);

  return (
    <Spin spinning={loading}>
      {/* <ChartComponent type="bar" data={chartPlatformCostData} options={chartPlatformOptions} /> */}
      <ReChartComponent type="bar" data={chartPlatformCostData} options={chartPlatformOptions} height={150} />
    </Spin>
  )
}
export default ChartPlatformCost;